import { createFileRoute } from "@tanstack/react-router";
import { QuoteEditor } from "@/components/QuoteEditor";

export const Route = createFileRoute("/_authenticated/predracun/nov")({
  head: () => ({ meta: [{ title: "Nov predračun — kupish.si" }] }),
  component: () => <QuoteEditor />,
});
